export default __webpack_public_path__ + "assets/images/f6958113f425ad0c189287abceef73f3.png";